'use strict';

export class CopyToClipboard {

	init(buttonClass) {
		const copyToClipboardButtons = document.querySelectorAll(buttonClass);
		if (!copyToClipboardButtons || copyToClipboardButtons.length === 0) {
			return;
		}

		copyToClipboardButtons.forEach((button) => {
			button.addEventListener('click', async () => {
				const clipboardWrapper = button.closest('.copy_to_clipboard_wrapper');
				const textarea = clipboardWrapper?.querySelector('textarea');
				if (!textarea) {
					return;
				}
				textarea.select();
				textarea.setSelectionRange(0, 99999); // For mobile devices

				await navigator.clipboard.writeText(textarea.value);
				alert(wp.i18n.__('Copied to clipboard', 'levcharity'));
			});
		})
	}
}
